import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileText"><Path fillRule="evenodd" clipRule="evenodd" d="M12 10H20V22H4V2H12V10ZM8 19H16.5V17H8V19ZM8 15H13V13H8V15Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileText;
